import React from 'react';
import { StylesHelper } from '../../../models/helpers/stylesHelper';
import { View, Image, Pressable } from 'react-native';
import CustomButton from '../CustomButton';
import Label, { LabelType } from '../Label';
import useTranslation from '../../../hooks/translation-hook';
import useCustomTheme from '../../../hooks/theme-hook';
import { getSurveySubmissionErrorKey } from '../survey-runtime/surveySubmissionFailure';

export interface SurveyErrorProps {
  error?: unknown;
  onTryAgainClick?(): void;
  onContactClick?(): void;
  onMyMissionsClick?(): void;
}

const SurveyError = (props: SurveyErrorProps) => {
  const theme = useCustomTheme();
  const t = useTranslation();
  const tMission = useTranslation({ defaultPath: 'mission' });
  const errorLinkColor = theme.isDark ? (theme.text.darkTurquoiseTwo?.toString() ?? '#5FC8BA') : theme.colorErrorPrimary;

  return (
    <View
      style={{
        height: '100%',
        flexGrow: 1,
        flexShrink: 1,
        flexDirection: 'column',
        alignContent: 'center',
        justifyContent: 'center',
        ...StylesHelper.padding(16, 24),
      }}
    >
      <View style={{ flexGrow: 1, flexShrink: 1, flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', marginTop: 16 }}>
        <View style={{ alignContent: 'center', justifyContent: 'center', flexShrink: 1, width: '100%', maxWidth: 420 }}>
          <Image style={{ width: 229, height: 274, alignSelf: 'center' }} source={require('../../../../assets/SurveyError.png')} />
          <Label variant={LabelType.titleLargeNoCapsPrimary} style={{ textAlign: 'center', fontWeight: '800', fontSize: 30, flexShrink: 1, marginTop: 16 }}>
            {t('survey-submit-failed-title')}
          </Label>
          <View accessibilityRole="alert" style={{ marginVertical: 24 }}>
            <Label numberOfLines={0} style={{ textAlign: 'center', fontSize: 14, lineHeight: 20 }}>
              {t(getSurveySubmissionErrorKey(props.error))}
            </Label>
          </View>
          {props.onMyMissionsClick && (
            <CustomButton secondary title={t('my_missions')} onPress={props.onMyMissionsClick} style={{ marginBottom: 12 }} />
          )}
          <CustomButton
            title={t('retry')}
            onPress={() => {
              if (props.onTryAgainClick) {
                props.onTryAgainClick();
              }
            }}
            style={{ flexShrink: 1 }}
          />
          <Pressable
            onPress={() => {
              if (props.onContactClick) {
                props.onContactClick();
              }
            }}
          >
            <Label variant={LabelType.body1} style={{ color: errorLinkColor, textAlign: 'center', marginTop: 8 }}>
              {tMission('still-problems-contact')}
            </Label>
          </Pressable>
        </View>
      </View>
    </View>
  );
};

export default SurveyError;
